<template>
  <div>
    <div class="feedback-container">
      <div class="scroll-container-outer">
        <div class="feedback-container-item">
          <div v-for="(item, idx) in feedbackList" :key="idx" class="feedback-item">
            <div class="feedback-item-text" v-if="!item.is_reply">
              <img class="text-box-icon-container" src="https://a1.wanwanshequ.com/static/public/avatar_default.jpg">
              <div class="text-box">{{item.content_text}}</div>
            </div>
            <div class="feedback-item-text-reply" v-else>
              <icon name="service" class="text-box-icon-container"/>
              <div class="text-box-reply">{{item.content_text}}</div>
            </div>
          </div>
        </div>
      </div>

      <field v-model="feedbackText" placeholder="请输入留言" autosize style="font-size: 12px;">
        <Button slot="button" size="small" type="primary" :loading="feedbackLoading" @click="DoPostFeedback">
          提交留言
        </Button>
      </field>
    </div>
  </div>
</template>

<script>
  import {Field, Button, Icon, Toast} from "vant"

  export default {
    name: "Feedback",
    components: {
      Field, Button, Icon, Toast
    },
    data() {
      return {
        feedbackList: [],
        feedbackText: "",
        showFeedback: false,
        feedbackLoading: false,
        chatMethod: null,
        unreadCount: 0,
      }
    },

    methods: {
      DoPostFeedback() {
        let params = {
          content: this.feedbackText,
        }
        if (this.feedbackText === "") {
          return
        }
        this.feedbackLoading = true
        this.$store.dispatch("PostFeedbackData", params).then(data => {
          if (data.code === 0) {
            Toast("留言成功")
            this.feedbackText = ""
          } else {
            if (data.code === 20010) {
              Toast("请先登录")
            } else {
              Toast("留言失败")
            }
          }
          this.GetFeedbackData()
          this.feedbackLoading = false
        }, () => {
          Toast("网络异常")
          this.feedbackLoading = false
        })
      },
      GetFeedbackData() {
        this.$store.dispatch("GetFeedbackData").then(data => {
          if (data.code === 0) {
            this.feedbackList = data.data
          }
        }, () => {
        })
      },

      GetFeedbackUnreadCount() {
        this.$store.dispatch("GetFeedbackUnreadCount").then(data => {
          if (data.code === 0) {
            this.unreadCount = data.data.count
          }
        }, () => {

        })
      },
      toChat() {
        this.showFeedback = true
      },

      checkChat() {
        this.chatMethod = setInterval(() => {
          this.GetFeedbackData()
          console.log("get feedback")
        }, 2000);
      },

      stopChat() {
        if (this.chatMethod) {
          clearInterval(this.chatMethod)
        }
      },
    },
    mounted() {
      this.GetFeedbackUnreadCount()
    },
    activated() {
      this.GetFeedbackUnreadCount()
    },
    computed: {
      unreadCountDisplay() {
        if (this.unreadCount) {
          return this.unreadCount
        } else {
          return ""
        }
      }
    },
    watch: {
      showFeedback(newval, oldval) {
        if (newval) {
          this.unreadCount = 0
          this.GetFeedbackData()
          this.checkChat()
        } else {
          this.stopChat()
        }
      }
    }
  };
</script>

<style scoped>
  .feedback-container {
    width: 98%;
    display: flex;
    flex-direction: column;
    background: ghostwhite;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
  }

  .scroll-container-outer {
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 50vh;
  }

  .feedback-container-item {
    padding: 10px 10px;
    min-height: calc(100% + 1px);
    display: flex;
    flex-direction: column-reverse;
  }

  .feedback-item {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .feedback-item-text {
    display: flex;
    font-size: 12px;
    margin-top: 5px;

    flex-direction: row-reverse;
    color: dimgrey;
  }

  .feedback-item-text-reply {
    font-size: 12px;
    margin-top: 5px;
    display: flex;
  }

  .text-box-icon-container {
    width: 15px;
    height: 15px;

    background: white;
    flex: 0 0 auto;
    padding: 3px;
    margin: 0 8px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }

  .text-box {
    background: #00a600;
    padding: 2px 9px;
    color: white;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
  }

  .text-box-reply {
    background: #f36581;
    padding: 2px 9px;
    color: white;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
  }

  .chat {
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    position: fixed;
    z-index: 100;
    right: 15px;
    bottom: 125px;
    background-color: rgba(128, 128, 128, 0.42);
    color: #ffffff;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .feedback-tip-container {
    padding: 8px 0;
    font-size: 12px;
    color: grey;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .popup-container {
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
  }

  .popup-wx-container {
    width: 120px;
    height: 160px;
    padding: 5px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center
  }

  .qr-text {
    padding-left: 3px;
    padding-right: 3px;
    padding-bottom: 5px;
    font-size: 13px;
  }

  .qr-img {
    width: 80px;
    height: 80px;
  }

</style>
